import React, { useState } from "react"
import { Link } from "react-router-dom"
import MDBox from "components/MDBox"
import MDInput from "components/MDInput"
import MDButton from "components/MDButton"
import MDTypography from "components/MDTypography"
import { useLoading } from "../LoadingContext"
import { authResetPassword } from "../../api/auth_reset_password"
import { Card } from "@mui/material"
import BasicLayout from "../components/BasicLayout"

const ResetPasswordPage: React.FC = () => {
  const { startLoading, stopLoading } = useLoading()
  const [mail, setMail] = useState<string>("")
  const [errorMessage, setErrorMessage] = useState<string>("")
  const [isFinish, setIsFinish] = useState<boolean>(false)

  const handleMailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setMail(e.target.value)
  }

  const validate = () => {
    let hasError = false

    if (!mail || mail === "") {
      setErrorMessage("必須項目が入力されていません")
      hasError = true
    } else if (mail.length > 64) {
      setErrorMessage("入力文字数は64文字以内です")
      hasError = true
    } else {
      setErrorMessage("")
    }

    return !hasError
  }

  const handleSubmit = async () => {
    if (validate()) {
      try {
        startLoading()
        await authResetPassword(mail, 0)
        setErrorMessage("")
        setIsFinish(true)
      } catch (error: any) {
        if (error.response) {
          const errorDetail = error.response.data.detail
          setErrorMessage(errorDetail.message)
        } else {
          setErrorMessage("サーバーへの接続に失敗しました")
        }
      } finally {
        stopLoading()
      }
    }
  }

  return (
    <BasicLayout>
      <Card>
        {!isFinish ? (
          <>
            <MDBox textAlign="center" pt={6} pb={4}>
              <MDTypography variant="h4" fontWeight="medium" mb={3}>
                パスワード初期化要求
              </MDTypography>
            </MDBox>
            <MDBox px={6} pb={4}>
              <MDBox component="form" role="form">
                <MDBox mb={1}>
                  <MDInput
                    type="email"
                    label="Email Address"
                    onChange={handleMailChange}
                    fullWidth
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "4px",
                        "& fieldset": {
                          borderColor: "rgba(0, 0, 0, 0.1)"
                        },
                        "&:hover fieldset": {
                          borderColor: "rgba(0, 0, 0, 0.2)"
                        }
                      }
                    }}
                  />
                </MDBox>
              </MDBox>
              {errorMessage && (
                <MDBox
                  color="#FF0000" // テキスト色
                  mb={2} // 下マージン
                  fontSize="0.7em" // フォントサイズ
                >
                  {errorMessage}
                </MDBox>
              )}
              <MDBox textAlign="center" sx={{ mt: 3, mb: 2 }}>
                <MDButton
                  variant="contained"
                  color="primary"
                  fullWidth
                  sx={{
                    borderRadius: "4px",
                    textTransform: "none",
                    fontSize: "1rem",
                    padding: "0.75rem 0"
                  }}
                  onClick={() => {
                    handleSubmit()
                  }}
                >
                  送信
                </MDButton>
              </MDBox>
              <MDBox textAlign="right">
                <MDTypography
                  component={Link}
                  to="/login"
                  variant="button"
                  color="info"
                  sx={{ textDecoration: "none", pr: 2 }}
                >
                  戻る
                </MDTypography>
              </MDBox>
            </MDBox>
          </>
        ) : (
          <>
            <MDBox textAlign="center" pt={6} pb={4}>
              <MDTypography variant="h4" fontWeight="medium" mb={3}>
                パスワード初期化要求完了
              </MDTypography>
            </MDBox>
            <MDBox px={6} pb={4}>
              <MDBox textAlign="center" mb={2}>
                パスワード初期化を要求しました
              </MDBox>
              <MDBox textAlign="right">
                <MDTypography
                  component={Link}
                  to="/login"
                  variant="button"
                  color="info"
                  sx={{ textDecoration: "none" }}
                >
                  戻る
                </MDTypography>
              </MDBox>
            </MDBox>
          </>
        )}
      </Card>
    </BasicLayout>
  )
}

export default ResetPasswordPage
